.searchTab {
  all: unset;
  cursor: pointer;
  padding: 15px 0;
  font: var(--font-body-md-regular);
  color: var(--semantic-colors-typography-faded);
  text-align: center;
  text-transform: capitalize;
  transition: border .3s ease, color .3s ease;
  border-bottom: 2px solid transparent;

  &:hover {
    color: var(--primitives-colors-neutral-0);
  }

  &.isActive {
    color: var(--primitives-colors-neutral-0);
    font: var(--font-body-md-semibold);
    border-color: var(--primitives-colors-neutral-0);
  }
}